(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function isMobileHeader() {
    return window.matchMedia('(max-width: 1099px)').matches;
  }

  function setMobileMenuTop() {
    var header = document.querySelector('[data-sticky-header]');
    if (!header) return;
    document.documentElement.style.setProperty('--mobile-menu-top', header.getBoundingClientRect().bottom + 'px');
  }

  function closeMobileMenu(nav, button) {
    nav.classList.remove('is-open');
    document.body.classList.remove('mobile-menu-open');
    if (button) {
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-label', 'Open menu');
    }
  }

  function getFocusable(container) {
    return Array.prototype.slice.call(container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
  }

  function setupHeader() {
    var button = document.querySelector('[data-mobile-menu-button]');
    var nav = document.querySelector('[data-primary-nav]');
    if (!button || !nav) return;
    if (button.dataset.headerReady === 'true') return;
    button.dataset.headerReady = 'true';
    var main = document.querySelector('main, [role="main"], #MainContent');

    function trapTab(event) {
      if (event.key !== 'Tab' || !nav.classList.contains('is-open')) return;
      var f = getFocusable(nav);
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (!nav.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      } else if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function openMenu() {
      nav.classList.add('is-open');
      document.body.classList.add('mobile-menu-open');
      button.setAttribute('aria-expanded', 'true');
      button.setAttribute('aria-label', 'Close menu');
      if (main && isMobileHeader()) {
        main.setAttribute('inert', '');
        main.setAttribute('aria-hidden', 'true');
      }
      setMobileMenuTop();
      var f = getFocusable(nav);
      if (f.length) f[0].focus();
      document.addEventListener('keydown', trapTab, true);
    }

    function doClose() {
      var wasOpen = nav.classList.contains('is-open');
      closeMobileMenu(nav, button);
      if (main) {
        main.removeAttribute('inert');
        main.removeAttribute('aria-hidden');
      }
      document.removeEventListener('keydown', trapTab, true);
      if (wasOpen) {
        try { button.focus(); } catch (e) {}
      }
    }

    button.setAttribute('aria-expanded', 'false');
    button.addEventListener('click', function () {
      if (nav.classList.contains('is-open')) doClose();
      else openMenu();
    });

    nav.querySelectorAll('.nav-item.has-dropdown > .nav-link, .nav-item.has-mega > .nav-link').forEach(function (link) {
      link.addEventListener('click', function (event) {
        if (!isMobileHeader()) return;
        event.preventDefault();
        var item = link.closest('.nav-item');
        if (!item) return;
        var open = !item.classList.contains('is-open');
        nav.querySelectorAll('.nav-item.is-open').forEach(function (other) {
          if (other !== item) other.classList.remove('is-open');
        });
        item.classList.toggle('is-open', open);
        link.setAttribute('aria-expanded', open ? 'true' : 'false');
        setMobileMenuTop();
      });
    });

    document.addEventListener('click', function (event) {
      if (!isMobileHeader() || !nav.classList.contains('is-open')) return;
      if (event.target.closest('[data-primary-nav]') || event.target.closest('[data-mobile-menu-button]')) return;
      doClose();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && nav.classList.contains('is-open')) doClose();
    });

    window.addEventListener('resize', function () {
      setMobileMenuTop();
      if (!isMobileHeader()) doClose();
    });
    setMobileMenuTop();
  }

  function setupMegaCarets() {
    document.querySelectorAll('.primary-nav .nav-item.has-mega').forEach(function (item) {
      if (item.dataset.caretReady === 'true') return;
      var link = item.querySelector('.nav-link');
      var mega = item.querySelector('.mega-menu');
      if (!link || !mega) return;
      item.dataset.caretReady = 'true';
      function placeArrow() {
        var lr = link.getBoundingClientRect();
        var mr = mega.getBoundingClientRect();
        var x = (lr.left + lr.width / 2) - mr.left;
        x = Math.max(22, Math.min(mr.width - 22, x));
        mega.style.setProperty('--arrow-left', x + 'px');
      }
      item.addEventListener('mouseenter', placeArrow);
      item.addEventListener('focusin', placeArrow);
    });
  }

  /* ---------- Desktop nav: keep aria-expanded in sync with hover/focus reveal ----------
     On desktop the dropdown/mega panels open via CSS :hover / :focus-within, so the
     trigger's aria-expanded (static "false" in markup) would otherwise never update for
     screen-reader / keyboard users. The mobile click handler in setupHeader() owns the
     attribute on small screens, so these handlers no-op there. */
  function setupDesktopNavAria() {
    document.querySelectorAll('.primary-nav .nav-item.has-dropdown, .primary-nav .nav-item.has-mega').forEach(function (item) {
      if (item.dataset.ariaSyncReady === 'true') return;
      item.dataset.ariaSyncReady = 'true';
      var link = item.querySelector('.nav-link');
      if (!link) return;
      function set(open) {
        if (isMobileHeader()) return; // mobile click handler manages this on small screens
        link.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      item.addEventListener('mouseenter', function () { set(true); });
      item.addEventListener('mouseleave', function () { set(false); });
      item.addEventListener('focusin', function () { set(true); });
      item.addEventListener('focusout', function () {
        setTimeout(function () {
          if (!item.contains(document.activeElement)) set(false);
        }, 0);
      });
    });
  }

  function snapFinalCta() {
    var card = document.querySelector('.final-cta');
    if (!card) return;
    function snapHeight() {
      card.style.paddingBottom = '';
      var basePad = parseFloat(getComputedStyle(card).paddingBottom) || 0;
      var h = card.getBoundingClientRect().height;
      var frac = h - Math.floor(h);
      if (frac > 0.02 && frac < 0.98) {
        card.style.paddingBottom = (basePad + (frac <= 0.5 ? -frac : (1 - frac))) + 'px';
      }
    }
    snapHeight();
    window.addEventListener('resize', snapHeight);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(snapHeight);
  }

  function setupPredictiveSearch() {
    document.querySelectorAll('[data-predictive-search]').forEach(function (root) {
      if (root.dataset.predictiveReady === 'true') return;
      var input = root.querySelector('[data-predictive-input]');
      var panel = root.querySelector('[data-predictive-results]');
      var predictiveUrl = root.getAttribute('data-predictive-url');
      if (!input || !panel || !predictiveUrl) return;
      root.dataset.predictiveReady = 'true';

      var debounceTimer = null;
      var activeController = null;
      var activeIndex = -1;

      function options() {
        return Array.prototype.slice.call(panel.querySelectorAll('[data-predictive-option]'));
      }

      function clearActive() {
        options().forEach(function (el) {
          el.classList.remove('is-active');
          el.setAttribute('aria-selected', 'false');
        });
        input.removeAttribute('aria-activedescendant');
        activeIndex = -1;
      }

      function setActive(index) {
        var opts = options();
        if (!opts.length) return;
        if (index < 0) index = opts.length - 1;
        if (index >= opts.length) index = 0;
        opts.forEach(function (el) {
          el.classList.remove('is-active');
          el.setAttribute('aria-selected', 'false');
        });
        var current = opts[index];
        current.classList.add('is-active');
        current.setAttribute('aria-selected', 'true');
        if (current.id) input.setAttribute('aria-activedescendant', current.id);
        if (typeof current.scrollIntoView === 'function') {
          current.scrollIntoView({ block: 'nearest' });
        }
        activeIndex = index;
      }

      function openPanel() {
        if (panel.hidden && panel.innerHTML.trim() === '') return;
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }

      function closePanel() {
        panel.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        clearActive();
      }

      function runSearch(term) {
        if (activeController && typeof activeController.abort === 'function') {
          activeController.abort();
        }
        var url = predictiveUrl
          + (predictiveUrl.indexOf('?') === -1 ? '?' : '&')
          + 'q=' + encodeURIComponent(term)
          + '&section_id=predictive-search'
          + '&resources[type]=product,page,article'
          + '&resources[limit]=6';

        var fetchOpts = {};
        if (typeof AbortController === 'function') {
          activeController = new AbortController();
          fetchOpts.signal = activeController.signal;
        }

        fetch(url, fetchOpts)
          .then(function (response) {
            if (!response.ok) throw new Error('Predictive search request failed');
            return response.text();
          })
          .then(function (html) {
            panel.innerHTML = html;
            clearActive();
            openPanel();
          })
          .catch(function () {
            // Graceful failure: leave the panel as-is so the GET form still submits.
          });
      }

      input.addEventListener('input', function () {
        var term = input.value.trim();
        if (debounceTimer) clearTimeout(debounceTimer);
        if (term.length < 2) {
          closePanel();
          return;
        }
        debounceTimer = setTimeout(function () {
          runSearch(term);
        }, 300);
      });

      input.addEventListener('focus', function () {
        if (panel.innerHTML.trim() !== '' && input.value.trim().length >= 2) openPanel();
      });

      input.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown') {
          if (panel.hidden) { openPanel(); return; }
          event.preventDefault();
          setActive(activeIndex + 1);
        } else if (event.key === 'ArrowUp') {
          if (panel.hidden) return;
          event.preventDefault();
          setActive(activeIndex - 1);
        } else if (event.key === 'Enter') {
          var opts = options();
          if (!panel.hidden && activeIndex > -1 && opts[activeIndex]) {
            var link = opts[activeIndex].matches('a') ? opts[activeIndex] : opts[activeIndex].querySelector('a');
            if (link && link.href) {
              event.preventDefault();
              window.location.href = link.href;
            }
          }
          // Otherwise let the form submit normally (no-JS fallback path).
        } else if (event.key === 'Escape') {
          if (!panel.hidden) {
            event.preventDefault();
            closePanel();
          }
        }
      });

      root.addEventListener('focusout', function () {
        // Defer so focus can land on a result link inside the panel without closing it.
        setTimeout(function () {
          if (!root.contains(document.activeElement)) closePanel();
        }, 0);
      });

      document.addEventListener('click', function (event) {
        if (!root.contains(event.target)) closePanel();
      });
    });
  }

  ready(function () {
    setupHeader();
    setupMegaCarets();
    setupDesktopNavAria();
    snapFinalCta();
    setupPredictiveSearch();
  });

  document.addEventListener('shopify:section:load', function () {
    setupHeader();
    setupMegaCarets();
    setupDesktopNavAria();
    setupPredictiveSearch();
  });
})();
